import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  IconButton,
  Drawer,
  Grid,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DocumentItem from "../../../Components/Masters/DocumentItem";

const formatMonthYear = (value) => {
  if (!value) return "-";

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  if (typeof value === "object" && value.month && value.year) {
    return `${monthNames[Number(value.month) - 1] || value.month} ${value.year}`;
  }

  if (typeof value === "string") {
    const ymMatch = value.match(/^(\d{4})-(\d{1,2})$/);
    if (ymMatch) {
      return `${monthNames[Number(ymMatch[2]) - 1] || ymMatch[2]} ${ymMatch[1]}`;
    }

    const parsed = new Date(value);
    if (!Number.isNaN(parsed.getTime())) {
      return `${monthNames[parsed.getMonth()]} ${parsed.getFullYear()}`;
    }
  }

  return value;
};

const productMasterFromElement = (el) =>
  el?.productMaster && typeof el.productMaster === "object"
    ? el.productMaster
    : null;

function ViewData({
  title,
  inputData,
  element,
  viewData,
  setViewData,
  handleEdit,
  companyAdmin,
  setData,
}) {
  const [filteredData, setFilteredData] = useState({});

  useEffect(() => {
    if (element) {
      setFilteredData(element);
    }
  }, [element]);

  const list = () => (
    <Box
      display="flex"
      gap={3}
      sx={{
        width: "26.5rem",
        maxWidth: "100%",
        height: "100vh",
        justifyContent: "space-between",
        backgroundColor: "transparent",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "3%",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton
          onClick={() => {
            setViewData(false);
            setData({});
          }}
          sx={{ color: "black" }}
        >
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box
        sx={{ p: 3, width: "100%", backgroundColor: "#fff", overflow: "auto" }}
      >
        <Typography
          variant="h6"
          sx={{
            textDecoration: "underline",
            fontWeight: "bold",
            mb: 2,
          }}
        >
          {title}
        </Typography>
        <Grid
          spacing={2}
          sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1rem" }}
        >
          {inputData?.map((input) => {
            let value = filteredData?.[input.fieldName];
            const pm = productMasterFromElement(filteredData);

            if (
              input.fieldName === "productId" ||
              input.fieldName === "productName"
            ) {
              value =
                input.fieldName === "productId"
                  ? pm?.productId ?? filteredData?.productId ?? value
                  : pm?.productName ?? filteredData?.productName ?? value;
            }

            if (input.fieldName === "endOfLifeTreatmentMethod") {
              value =
                pm?.disposalMethod ??
                filteredData?.endOfLifeTreatmentMethod ??
                value;
            }

            if (input.fieldName === "averageWeightPerUnit") {
              const w =
                pm?.averageWeightPerUnit ??
                pm?.weight ??
                filteredData?.averageWeightPerUnit;
              value =
                w !== undefined && w !== null && w !== "" ? String(w) : value;
            }

            if (input.fieldName === "soldUnit") {
              value = pm?.soldUnit ?? filteredData?.soldUnit ?? value;
            }

            if (input.fieldName === "eolMonth") {
              value = formatMonthYear(value);
            }

            if (value === undefined || value === null || value === "") {
              value = "-";
            }

            return (
              <Grid item xs={12} sm={12} key={input.fieldName} mb={1}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: "bold",
                    wordBreak: "break-word",
                  }}
                >
                  {input.title}
                </Typography>
                <div style={{ wordBreak: "break-word" }}>{value}</div>
              </Grid>
            );
          })}
        </Grid>

        <Box sx={{ mt: 2 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
            Documents Uploaded
          </Typography>
          {element && element?.documents?.length > 0 ? (
            <Box
              display="flex"
              flexDirection="column"
              gap={2}
              sx={{ width: "100%" }}
            >
              <Box display="flex" flexWrap="wrap" gap={1}>
                {element?.documents
                  .filter((url) =>
                    ["png", "jpg", "jpeg"].includes(
                      url.split(".").pop().toLowerCase()
                    )
                  )
                  ?.map((url, index) => (
                    <DocumentItem key={`image-${index}`} url={url} />
                  ))}
              </Box>

              <Box display="flex" flexWrap="wrap" gap={1}>
                {element?.documents
                  .filter(
                    (url) =>
                      !["png", "jpg", "jpeg"].includes(
                        url.split(".").pop().toLowerCase()
                      )
                  )
                  ?.map((url, index) => (
                    <DocumentItem key={`file-${index}`} url={url} />
                  ))}
              </Box>
            </Box>
          ) : (
            <Typography>-</Typography>
          )}
        </Box>

        {!companyAdmin && (
          <Button
            variant="contained"
            sx={{ mt: 2, backgroundColor: "#0a3f73", textTransform: "none" }}
            onClick={() => handleEdit(element)}
          >
            Edit
          </Button>
        )}
      </Box>
    </Box>
  );

  return (
    <Drawer
      anchor="right"
      open={viewData}
      onClose={() => {
        setViewData(false);
        setData({});
      }}
      sx={{
        "& .MuiDrawer-paper": {
          backgroundColor: "transparent",
          boxShadow: "none",
        },
      }}
    >
      {list()}
    </Drawer>
  );
}

export default ViewData;

